module.exports = __webpack_public_path__ + "static/media/Xay-dung-20.6066d860.svg";